import { Link } from "react-router-dom";

export const Logo = ({ dark = false, to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" className="flex items-center gap-2.5 group">
    <img
      src="/img/logo-taxi.png"
      alt="Comfort Taxi logo"
      data-testid="brand-logo-image"
      className="h-11 w-11 object-contain drop-shadow-md transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105"
    />
    <span className="leading-tight">
      <span className={`block font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
        Comfort <span className={dark ? "text-amber-400" : "text-blue-700"}>Taxi</span>
      </span>
      <span className={`block text-[10px] font-semibold uppercase tracking-[0.2em] ${dark ? "text-blue-200" : "text-slate-500"}`}>
        Port Moresby
      </span>
    </span>
  </Link>
);
